/** Путь страницы в том виде, в котором его сравнивает /api/seo/public. */
export function normalizeSeoPath(raw) {
  let value = raw == null ? '' : String(raw).trim()
  if (!value) return ''

  let hash = ''
  const hashAt = value.indexOf('#')
  if (hashAt !== -1) {
    hash = value.slice(hashAt)
    if (hash === '#') hash = ''
    value = value.slice(0, hashAt)
  }

  const queryAt = value.indexOf('?')
  if (queryAt !== -1) value = value.slice(0, queryAt)

  if (/^https?:\/\//i.test(value)) {
    try {
      value = new URL(value).pathname || '/'
    } catch (e) {
      value = '/'
    }
  }

  if (!value || value[0] !== '/') value = `/${value}`
  value = value.replace(/\/+/g, '/')
  if (value.length > 1) value = value.replace(/\/+$/, '')

  return (value || '/') + hash
}

export function routeSeoPath(route) {
  const path = normalizeSeoPath((route && route.path) || '/')
  const hash = route && route.hash && route.hash !== '#' ? route.hash : ''
  return path + hash
}
